module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8017.e6b780f2.png";